/**
 * StudioSection — 에이전트 쇼케이스 (Figma 2828:1847)
 *
 * 시안 갱신(2026-07-31)으로 스튜디오 UI 목업과 AgentCard 6장이 단일 이미지
 * (2851:2483)로 대체됐다. 그래서 이 섹션은 헤드라인 3줄 + 이미지 1장이 전부다.
 * 이미지가 1228px로 컨테이너(1152px)보다 넓어 시안에서도 살짝 넘친다.
 *
 * 색은 landing.css의 --lp-* 변수만 쓴다 (D-07 §1.2 랜딩페이지 예외).
 */
export function StudioSection() {
  return (
    <section
      id="agents"
      className="lp-section-full flex w-full flex-col items-center justify-center bg-[var(--lp-studio-surface)] py-24"
    >
      <div className="mx-auto flex w-full max-w-[1152px] flex-col items-center gap-4 px-8 text-center">
        <p className="lp-kicker">인디피아 스튜디오</p>

        <h2 className="max-w-[768px] text-[28px] font-bold leading-[1.3] text-[var(--lp-heading)] sm:text-[34px] lg:text-[40px]">
          스튜디오에서 <span className="text-[var(--lp-brand)]">바로 쓸 수 있는</span> 에이전트 3,
          <br />
          출시예정 3
        </h2>

        <p className="max-w-[512px] text-base leading-[1.5] text-[var(--lp-text-soft)]">
          에이전트들은 모두 인디피아 스튜디오 안에 있습니다.
          <br />
          필요한 에이전트만 골라 내 스튜디오에 담아보세요.
        </p>
      </div>

      {/* 에이전트 목록 이미지 — 시안에서 컨테이너보다 넓게 넘친다 */}
      <div className="mt-14 w-full overflow-hidden px-8">
        <img
          src="/landing/studio-mockup.png"
          alt="인디피아 스튜디오에 담을 수 있는 에이전트 6종 — 출시 3, 출시예정 3"
          className="mx-auto h-auto w-full max-w-[1228px]"
        />
      </div>
    </section>
  );
}
